import { STORY_FONTS, type StoryLayer } from './story-design';

export const isStoryTextLayer = (layer: StoryLayer) => ['text', 'emoji', 'link', 'mention', 'hashtag', 'location'].includes(layer.type);
const cache = new Map<string, number>();

/** Measure only after text/style changes, never in the pointer-move hot path. */
export function fitStoryTextLayer(layer: StoryLayer, patch: Partial<StoryLayer>): StoryLayer {
  const next = { ...layer, ...patch };
  if (!isStoryTextLayer(next) || !['text', 'font', 'fontSize', 'width', 'bold', 'italic', 'box', 'handle'].some(key => key in patch) || typeof document === 'undefined') return next;
  const text = next.type === 'mention' ? `@${next.handle}` : next.type === 'link' ? `↗ ${next.text}` : next.type === 'location' ? `📍 ${next.text}` : next.type === 'hashtag' ? `#${next.text.replace(/^#/, '')}` : next.text || 'Ag';
  const padding = next.box === 'none' ? 0 : 16;
  const key = JSON.stringify([text, next.font, next.fontSize, next.width, next.bold, next.italic, padding]);
  let height = cache.get(key);
  if (height === undefined) {
    const measure = document.createElement('div');
    Object.assign(measure.style, { position: 'fixed', left: '-10000px', top: '0', visibility: 'hidden', pointerEvents: 'none', width: `${Math.max(8, next.width - padding)}px`, fontFamily: STORY_FONTS[next.font], fontSize: `${next.fontSize}px`, fontWeight: next.bold ? '700' : '400', fontStyle: next.italic ? 'italic' : 'normal', lineHeight: '1.2', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' });
    measure.textContent = text; document.body.append(measure);
    height = Math.min(1280, Math.max(24, Math.ceil(measure.getBoundingClientRect().height) + padding + 8)); measure.remove();
    if (cache.size >= 250) cache.clear(); cache.set(key, height);
  }
  const center = layer.y + layer.height / 2;
  return { ...next, height, y: patch.y === undefined ? Math.max(0, Math.min(640 - Math.min(height, 640), center - height / 2)) : next.y };
}
